import api from "../../helpers/api";





export const postFeedback = (formData) => api.post("forms/contact", {...formData});


